module.exports = __webpack_public_path__ + "img/drivingLicenceFile.26240f82.jpg";